<template>
  <div class="boss-main-content-wrap">
    <setting-header
      v-if="isCompanyStaffAccess"
      :breadcrumbs="[{ name: '求人確認' },{ name: '掲載前の求人', pathName: 'jobPrePublished' }]"
      title="掲載前の求人プレビュー_企業情報"
      class="hide-for-print"
    />
    <div class="pega-option-wrap">
      <div class="grid-x hide-for-print">
        <div class="cell auto">
          <sp-preview-button
            :id="id"
            :route-name="spRouteNameForCompany"
          />
        </div>
        <print-button class="cell shrink" />
      </div>
      <div class="pega-text-small">
        ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。
      </div>
      <company-preview-detail
        :is-light-plan="isLightPlan"
        :company-info="companyInfo"
        :report="report"
        :environment="environment"
      />

      <p class="margin-top-1 pega-hide-msg">
        これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。<br>
        あらかじめご了承ください。
      </p>

      <company-supplement-preview :company-supplement-info="companySupplementInfo" />
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import SpPreviewButton from '@/components/atoms/SpPreviewButton'
import PrintButton from '@/components/atoms/PrintButton'
import CompanyPreviewDetail from '@/components/organisms/CompanyPreviewDetail'
import CompanySupplementPreview from '@/components/organisms/CompanySupplementPreview'
import companyPreviewCommon from '@/lib/companyPreviewCommon'

export default {
  components: {
    CompanySupplementPreview,
    CompanyPreviewDetail,
    PrintButton,
    SpPreviewButton,
    SettingHeader
  },
  // PC・SP共通処理読み込み
  mixins: [companyPreviewCommon]
}
</script>
